import React from 'react';
import Icon from '../../../components/_base/Icon';
import { RegistrationResult, RegistrationResultType } from '../../../hooks/use-booking-subscription';
import { FAILURE_MESSAGES, FailureType, PRIMARY_COLOR } from '../../../lib/constants';

interface BookingFailureContentProps {
  onClose: () => void;
  onOverlayClick: (e: React.MouseEvent) => void;
  result?: RegistrationResult;
  isCancellation?: boolean;
  primaryColor?: string | null;
  failureType?: FailureType;
}

const BookingFailureContent: React.FC<BookingFailureContentProps> = ({
  onClose,
  onOverlayClick,
  result = RegistrationResultType.UNAVAILABLE,
  isCancellation = false,
  primaryColor,
  failureType: failureTypeProp
}) => {
  const getFailureType = (): FailureType => {
    if (failureTypeProp) return failureTypeProp;
    if (isCancellation) return FailureType.CANCELLATION;
    if (result === RegistrationResultType.UNAVAILABLE) return FailureType.UNAVAILABLE;
    return FailureType.GENERIC;
  };

  const { main: failureMessage, secondary: secondaryMessage } = FAILURE_MESSAGES[getFailureType()];
  const customStyle = { '--primary-color': primaryColor || PRIMARY_COLOR } as React.CSSProperties;

  return (
    <div className="booking-confirmation-modal-overlay" onClick={onOverlayClick} role="dialog" aria-modal="true" style={customStyle}>
      <div className="booking-confirmation-modal booking-confirmation-modal--failure">
        <div className="close-button-container">
          <button type="button" className="close-button" onClick={onClose} aria-label="Close">
            <Icon.Remove width="15" height="15" viewBox="0 0 24 24" />
          </button>
        </div>
        <div className="confirmation-content">
          <div className="failure-message">
            <div className="confirmation-icon confirmation-icon--failure">
              <Icon.WarningTriangleIcon />
            </div>
            <div className="failure-message-content">
              <p className="main-message main-message--failure">
                {failureMessage}
              </p>
              <p className="secondary-message">
                {secondaryMessage}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingFailureContent;

